import { render, staticRenderFns } from "./UnregisteredLandYN.vue?vue&type=template&id=fde81ea4"
import script from "./UnregisteredLandYN.vue?vue&type=script&lang=js"
export * from "./UnregisteredLandYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports